export default __webpack_public_path__ + "static/media/MwLeft.7bb749d4.svg";